import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/clients")({
  head: () => ({ meta: [{ title: "Clients | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-clients")),
});
